import { LOCALE_COOKIE_NAME } from '@/config';
import { Locale, type TranslatableLabel } from '@/types/i18n.types';
import CookieHelper from '@/utils/cookies';
import { getImportMetaEnvProp } from '@/utils/esmHelpers';

/**
 * Assigne la valeur de la langue sur l'élément HTML dans le DOM
 */
export function setDocumentLanguageAttribute(locale: Locale): void {
  document.documentElement.setAttribute('lang', locale);
}

/**
 * Validation que la locale fournie en paramètres soit supportée par l'application
 */
const isMatchingLocale = (locale: Locale): locale is Locale => Object.values<string>(Locale).indexOf(locale) > -1;

/**
 * Cherche la locale dans tous les endroits où elle peut être possiblement
 * stockée puis retourne la valeur au premier endroit où elle a été trouvée.
 */
export const getBaseLanguage = (): Locale => {
  const cookieLocale = new CookieHelper().getCookie(LOCALE_COOKIE_NAME);
  return isMatchingLocale(cookieLocale) ? cookieLocale : getImportMetaEnvProp('VITE_APP_I18N_LOCALE') as Locale;
};

export function getEmptyTranslatableLabel(): TranslatableLabel {
  return translatableLabelOfString('');
}

export function translatableLabelOfString(message: string): TranslatableLabel {
  return { fr: message, en: message };
}

/**
 * Type guard vérifiant que la valeur fournie en paramètres soit un objet de traduction,
 * en fonction de la présence (ou non) des propriétés de langue (si applicable).
 */
export function isTranslatableLabel(value: unknown): value is TranslatableLabel {
  return typeof value === 'object' &&
    value !== null &&
    Locale.fr in value && typeof value[Locale.fr] === 'string' &&
    Locale.en in value && typeof value[Locale.en] === 'string';
}
